import { render } from "./introduce.vue?vue&type=template&id=2f2dfa35&scoped=true"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"

import "./introduce.vue?vue&type=style&index=0&id=2f2dfa35&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.32_vue@3.4.32_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2dfa35"]])

export default __exports__